// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
:host h3 {
  margin-bottom: 10px;
}
:host:first-of-type {
  margin-top: 1rem;
}
:host .is-video {
  position: relative;
  width: 100%;
  height: auto;
}
:host .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}
:host .is-video img {
  height: auto;
}
:host ion-item.item {
  border: 1px solid var(--ion-color-light);
  border-radius: 8px;
  --padding-end: 0px;
  --padding-start: 0px;
  --inner-padding-end: 0px;
}
:host ion-item.itemion-item.item {
  margin-bottom: 1rem;
}
:host ion-item.item.space-between-elements {
  border-bottom: 1px solid var(--ion-color-light);
}
:host ion-item.item ion-label {
  display: flex;
  flex-direction: column;
  margin: 0;
  white-space: pre-wrap;
  width: 100%;
}
:host ion-item.item ion-label .content {
  padding: 1rem;
  position: relative;
}
:host ion-item.item ion-label .content h3 {
  word-wrap: normal;
  white-space: normal;
  line-height: 1.4;
}
:host ion-item.item ion-label .content .author {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-inline-end: 2rem;
}
:host ion-item.item ion-label .content .author avatar {
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
  min-width: 50px;
  min-height: 50px;
  margin-right: 1rem;
}
:host ion-item.item ion-label .content .author p.name {
  font-weight: bold !important;
}
:host ion-item.item ion-label .content .author p.date {
  display: flex;
  white-space: pre-wrap;
  color: var(--ion-color-medium);
  font-size: 80% !important;
}
:host ion-item.item ion-label .content .delete-message-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}
:host ion-item.item ion-label .content .message {
  font-size: 0.9rem !important;
}
:host ion-item.item ion-label .content .image-container {
  overflow: hidden;
  width: 100%;
  border-radius: 8px;
  margin-top: 1rem;
}
:host ion-item.item ion-label .content small {
  color: var(--ion-color-medium);
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
:host ion-item.item ion-label .content p {
  word-wrap: normal;
  color: var(--ion-color-dark);
  line-height: 1.5 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/wall/wall-item/wall-item.scss"],"names":[],"mappings":"AAAA;EAKE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAJE;EACE,mBAAA;AAMJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAEI;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AAAN;AAEI;EACE,YAAA;AAAN;AAIE;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;AAFJ;AAII;EACE,mBAAA;AAFN;AAKI;EACE,+CAAA;AAHN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AAJN;AAMM;EACE,aAAA;EACA,kBAAA;AAJR;AAMQ;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAJV;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;AALV;AAOU;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AALZ;AASY;EACE,4BAAA;AAPd;AAUY;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;AARd;AAaQ;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AAXV;AAcQ;EACE,4BAAA;AAZV;AAeQ;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAbV;AAgBQ;EACE,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;AAdV;AAiBQ;EACE,iBAAA;EACA,4BAAA;EACA,2BAAA;AAfV","sourcesContent":[":host {\n  h3 {\n    margin-bottom: 10px;\n  }\n\n  display: block;\n  margin-bottom: 1rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n\n  &:first-of-type {\n    margin-top: 1rem;\n  }\n\n  .is-video {\n    position: relative;\n    width: 100%;\n    height: auto;\n    .icon-play {\n      background-color: white;\n      border-radius: 50%;\n      height: 50px;\n      width: 50px;\n      top: calc(50% - 35px);\n      padding: 10px 7px 10px 13px;\n      left: calc(50% - 35px);\n      position: absolute;\n      box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n      color: var(--ion-color-dark);\n    }\n    img {\n      height: auto;\n    }\n  }\n\n  ion-item.item {\n    border: 1px solid var(--ion-color-light);\n    border-radius: 8px;\n    --padding-end: 0px;\n    --padding-start: 0px;\n    --inner-padding-end: 0px;\n\n    &ion-item.item {\n      margin-bottom: 1rem;\n    }\n\n    &.space-between-elements {\n      border-bottom: 1px solid var(--ion-color-light);\n    }\n\n    ion-label {\n      display: flex;\n      flex-direction: column;\n      margin: 0;\n      white-space: pre-wrap;\n      width: 100%;\n\n      .content {\n        padding: 1rem;\n        position: relative;\n\n        h3 {\n          word-wrap: normal;\n          white-space: normal;\n          line-height: 1.4;\n        }\n\n        .author {\n          display: flex;\n          align-items: center;\n          margin-bottom: 1rem;\n          padding-inline-end: 2rem;\n\n          avatar {\n            width: 50px;\n            height: 50px;\n            max-width: 50px;\n            max-height: 50px;\n            min-width: 50px;\n            min-height: 50px;\n            margin-right: 1rem;\n          }\n\n          p {\n            &.name {\n              font-weight: bold !important;\n            }\n\n            &.date {\n              display: flex;\n              white-space: pre-wrap;\n              color: var(--ion-color-medium);\n              font-size: 80% !important;\n            }\n          }\n        }\n\n        .delete-message-button {\n          position: absolute;\n          top: 0;\n          right: 0;\n          margin: 0;\n        }\n\n        .message {\n          font-size: 0.9rem !important;\n        }\n\n        .image-container {\n          overflow: hidden;\n          width: 100%;\n          border-radius: 8px;\n          margin-top: 1rem;\n        }\n\n        small {\n          color: var(--ion-color-medium);\n          margin-bottom: 20px;\n          display: flex;\n          width: 100%;\n          justify-content: space-between;\n        }\n\n        p {\n          word-wrap: normal;\n          color: var(--ion-color-dark);\n          line-height: 1.5 !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
